import React, { Component } from 'react';
import ezProLogo from '../../assets/images/ez_logo_original_rectangular.jpg'
import { Link } from 'react-router-dom';

export class ServiceComingSoon extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    render() {
        const { text = "We are new and would love to hear from you. Got any suggestions for us?" } = this.props
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img
                    id='helper_image'
                    src={ezProLogo}
                    style={{ height: '25rem', width: '35rem', borderRadius: 10 }} />
                <p style={{
                    fontSize: 22,
                    width: '65%',
                    textAlign: 'center'
                }}>{text}</p>
                <div style={{
                    marginTop: 50
                }}>
                    <p style={{
                        fontSize: 18,
                        backgroundColor: '#0078ff',
                        color: 'white',
                        padding: '10px 30px',
                        borderRadius: 5
                    }}>
                        <Link 
                        style={{
                            fontSize: 18,
                            fontWeight: 'bold',
                            // backgroundColor: '#0078ff',
                            color: 'white',
                            // padding: '10px 30px',
                            // borderRadius: 5
                        }}
                            to='#'
                            onClick={(e) => {
                                window.location.href = "mailto:admin@ezprohome.com";
                                e.preventDefault();
                            }}
                        >
                            E-mail Us
                        </Link>
                        </p>
                </div>
            </div>
        );
    }
}

export default ServiceComingSoon;


// WEBPACK FOOTER //
// ./src/views/Components/ServiceComingSoon.jsx